import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";

import "./App.css";
import "./Notification.css";

import Home from "./components/Home/Home";
import Login from "./components/Login";
import { redirect } from "./actions/common.actions";

const mapStateToProps = state => ({ ...state.common });
const mapDispatchToProps = dispatch => ({
  onRedirect: path => dispatch(redirect(path))
});
class App extends Component {
  componentWillReceiveProps(nextProps) {
    const path = nextProps.redirectTo;
    if (path) this.props.onRedirect(path);
  }

  componentDidMount() {
    toast.configure({ autoClose: 8000, draggable: false, enter: "zoomIn", exit: "zoomOut", duration: 750 });
  }

  render() {
    return (
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/" component={Home} />
      </Switch>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
